// @flow

export default window.fetch;
